import React from 'react'
import PackageComponent from '../../Package'
import { Category_Discover, } from '../../../utils/formatType'

export default function DiscoverCategory() {
  return (
    <div>
            <PackageComponent title="Khám phá" packageId={Category_Discover} />

    </div>
  )
}
